import { Brand } from '../../..';
import { PaginationResponse } from 'src/app/core/interfaces';
import { ConsumerPlan } from '../..';
import { SimonSimStatus } from '../../../simon';

export class GetConsumerEligibilityResponse extends PaginationResponse {
  brand: Brand;
  plans: ConsumerPlan[];
  preProvisioningPlan: ConsumerPlan;
  simStatus: SimonSimStatus;
}
